module.exports = __webpack_public_path__ + "static/emmerdale-studio-experience-sm-aac9d1a7c928e4c96610f9a0ae6ee563.jpg";